import { render, staticRenderFns } from "./FeedbackSuccess.vue?vue&type=template&id=e105d2ec&"
import script from "./FeedbackSuccess.vue?vue&type=script&lang=js&"
export * from "./FeedbackSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports